import { render, staticRenderFns } from "./PlanForm.vue?vue&type=template&id=207c0db4&scoped=true&"
import script from "./PlanForm.vue?vue&type=script&lang=js&"
export * from "./PlanForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207c0db4",
  null
  
)

export default component.exports